const libPictView = require('pict-view');

/** @type {any} */
const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-SolverPaneHtml-View'];

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class HeadlightPaneSolver extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}
	/** @param {()=>void} pCallback */
	onAfterRenderAsync(pCallback)
	{
		this.pict.views.PictFormsSolver.renderAsync(pCallback);
	}
}

module.exports = HeadlightPaneSolver;

module.exports.default_configuration = _ViewConfiguration;

// additional view-specific templates
const viewSpecificTemplates = [];

// append the view-specific templates to the global templates that are generated from the JSON file
_ViewConfiguration.Templates = [ ..._ViewConfiguration.Templates, ...viewSpecificTemplates ];
module.exports.default_configuration = _ViewConfiguration;
